import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';

import Header from '../header/Header';
import { clearPersister } from '../../utils/common';

import { useToken, useUserDetails } from '../../store/slices/authSlice';
import Footer from '../footer/Footer';
import CallingModal from '../Supervisor/CallingModal';
import ChatModal from '../Supervisor/ChatModal';
import {
  markAsRead,
  setSupervisorMsgList,
  useActiveChatDetails
} from '../../store/slices/tenantSlices/chatSlice';
import { socket } from '../../config/Socket';
import { toast } from 'react-toastify';

const AdminLayout = () => {
  const dispatch = useDispatch();
  const user = useUserDetails();
  const activeChatDetails = useActiveChatDetails();

  const token = useToken();

  useEffect(() => {
    const token = localStorage.getItem('callex-token');
    if (!token) {
      clearPersister(dispatch);
    }
  }, []);

  useEffect(() => {
    if (!user) return;

    socket.emit('identify', {
      user_id: user?.type === 'TenantAdmin' ? user.companyId : user.supervisorId,
      type: user?.type
    });

    const handleServerRestart = ({ message }) => {
      console.log('server_restart-------->', message);
      socket.emit('identify', {
        user_id: user?.type === 'TenantAdmin' ? user.companyId : user.supervisorId,
        type: user?.type
      });
    };

    socket.on('connect', () => {
      console.log('Socket connected: ', socket.id);
      socket.emit('identify', {
        user_id: user?.type === 'TenantAdmin' ? user.companyId : user.supervisorId,
        type: user?.type
      });
    });

    socket.on('reconnect', (attemptNumber) => {
      console.log('Socket reconnected after attempt ', attemptNumber);
      socket.emit('identify', {
        user_id: user?.type === 'TenantAdmin' ? user.companyId : user.supervisorId,
        type: user?.type
      });
    });

    socket.on('server_restart', handleServerRestart);

    return () => {
      socket.off('server_restart', handleServerRestart);
      socket.off('connect');
      socket.off('reconnect');
    };
  }, [user]);

  const onMarkAsRead = async (countObj) => {
    try {
      const payload = {
        toUserId: user?.supervisorId,
        toRole: 'supervisor',
        fromUserId: countObj?.fromUserId,
        fromRole: countObj?.fromRole
      };
      await dispatch(markAsRead(payload)).unwrap();
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    const handleChatMessage = (message) => {
      console.log('message------->', message);
      if (message?.fromUserId !== activeChatDetails?.user_id) {
        dispatch(setSupervisorMsgList({ id: message?.fromUserId, is_delete: false }));
        toast(
          <div>
            <strong
              style={{ textTransform: 'capitalize', fontWeight: 'bold', marginBottom: '4px' }}>
              {message?.fromRole}
            </strong>
            <div
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '250px'
              }}>
              {message?.filePath ? 'Attachment' : message?.message}
            </div>
          </div>,
          {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          }
        );
      } else {
        onMarkAsRead({ ...message });
      }
    };

    socket.on('chatMessage', handleChatMessage);

    return () => {
      socket.off('chatMessage', handleChatMessage);
    };
  }, [activeChatDetails]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <audio id="mediaElement" controls style={{ display: 'none' }}></audio>
      <Header />
      <div className="admin-outlet-container">
        <Outlet />
      </div>
      <Footer />
      {user?.type === 'supervisor' && (
        <React.Fragment>
          <div className="call-icon-container">
            <Icon.PhoneCall />
          </div>
          <CallingModal />
          {activeChatDetails && <ChatModal />}
        </React.Fragment>
      )}
    </>
  );
};

export default AdminLayout;
